import type { NavigateOptions } from '@gatsbyjs/reach-router';
import { useLocation } from '@gatsbyjs/reach-router';
import { navigate } from 'gatsby';

export function useNavigate() {
  const location = useLocation();

  function constructRoute(route: string, args?: Record<string, any>): string {
    const url = new URL(route, location.origin);
    if (args) {
      for (const key in args) {
        if (typeof args[key] !== 'undefined' && args[key] !== null) {
          const arg = args[key];
          url.searchParams.append(key, arg);
        }
      }
    }
    return `${url.pathname}${url.search}`;
  }

  async function navigateRoute(
    to: string,
    args?: Record<string, any>,
    options?: NavigateOptions<object>
  ) {
    const url = constructRoute(to, args);
    return navigate(url, options);
  }

  return { constructRoute, navigateRoute };
}
